import { TRPCClientError } from '@trpc/client';

type FieldErrors = Record<string, { message: string }[]>;

export function formatTRPCError(error: unknown): {
  fieldErrors: FieldErrors;
  formError: string | null;
} {
  // Default empty state
  const result = {
    fieldErrors: {} as FieldErrors,
    formError: null as string | null
  };

  if (error instanceof TRPCClientError) {
    // Handle Zod validation errors
    if (error.data?.zodError) {
      result.fieldErrors = error.data.zodError.fieldErrors;
    }
    // Handle other TRPC errors
    else {
      result.formError = error.message;
    }
  }
  // Handle generic errors
  else if (error instanceof Error) {
    result.formError = error.message;
  } else {
    result.formError = 'An unknown error occurred';
  }

  return result;
}
